{{#if ordered}}
  <ol class="{{list_class}}" id="{{id}}" role="list">
  {{#each items}}
    <li {{#if animation}}data-anijs="{{animation}}"{{/if}} class="{{class}}" id="{{id}}">
    {{t description}}
    {{#if blocks}}
      <div data-region="{{../cid}}-items-{{@index}}-blocks"></div>
    {{/if}}
    </li>
  {{/each}}
  </ol>
{{else if icon_decorated}}
  <ul class="fa-ul">
    {{#each items}}
    <li {{#if animation}}data-anijs="{{animation}}"{{/if}} 
      class="{{class}}" 
      id="{{id}}" 
      role="listitem">
      <span>
        {{>icon uuid=../cid index=@index prefix=icon_prefix name=icon_name classes=icon_size}}
      </span>
      <div class="list-text">
        {{#if header}}
          <div class="header">{{t header}}</div>
        {{/if}}
        <p class="description">{{t description}}</p>
        {{#if blocks}}
          <div data-region="{{../cid}}-items-{{@index}}-blocks"></div>
        {{/if}}
    </div>
    </li>
  {{/each}}
  </ul>

{{else}}

  <ul class="{{list_class}}" id="{{id}}" role="list">
  {{#each items}}
    <li {{#if animation}}data-anijs="{{animation}}"{{/if}} class="{{class}}" id="{{id}}" role="listitem">
    {{#if header}}<div class="header">{{t header}}</div>{{/if}}
    <p class="description">{{t description}}</p>
    {{#if blocks}}
      <div data-region="{{../cid}}-items-{{@index}}-blocks"></div>
    {{/if}}
    </li>
  {{/each}}
  </ul>
{{/if}}

